import { render, staticRenderFns } from "./info-carteira.vue?vue&type=template&id=f458daca&scoped=true&"
import script from "./info-carteira.vue?vue&type=script&lang=js&"
export * from "./info-carteira.vue?vue&type=script&lang=js&"
import style0 from "./info-carteira.vue?vue&type=style&index=0&id=f458daca&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f458daca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f458daca')) {
      api.createRecord('f458daca', component.options)
    } else {
      api.reload('f458daca', component.options)
    }
    module.hot.accept("./info-carteira.vue?vue&type=template&id=f458daca&scoped=true&", function () {
      api.rerender('f458daca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/consolidator/components/info-carteira/info-carteira.vue"
export default component.exports